import { findParentsById } from '@/utils/index'
export default {
  data() {
    return {
      isMobile: false
    };
  },
  filters: {
    removeLableAndImage(html) {
      let msg = html.replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
        .replace(/<br\/?>/gi, '\n').replace(/<[^>/]+>/g, '')
        .replace(/(\n)?<\/([^>]+)>/g, '').replace(/\u00a0/g, ' ')
        .replace(/&nbsp;/g, ' ').replace(/<\/?(img)[^>]*>/gi, '')
        .replace(/&amp;/g, "&").replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&#39;/g, "\'")
        .replace(/&quot;/g, "\"")
        .replace(/<\/?.+?>/g, "")
      return msg
    }
  },
  created() {
    this.Is_Mobile()
  },
  beforeMount() {
    window.addEventListener('resize', this.Is_Mobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.Is_Mobile)
  },
  methods: {
    Is_Mobile() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    handleClick(row) {
      if (!!row.link && row.link.indexOf('http') == 0) {
        window.open(row.link, row.style == 1 ? '_blank' : '_self');
      } else {
        // type 1: 资讯  2: 定制页
        // template 1: 单内容 2: 多内容
        let lastRow = row;
        if(!!row.children && !!row.children.length) {
          this.deepTree(row.children, (node, index) => {
            if(index == 0 && !node.children) {
              lastRow = node
            }
          })
        }
        this.$store.commit('user/SET_LASTROW', lastRow)
        let parentRows = []
        findParentsById(this.$store.getters.menus, row.id, parentRows)
        this.$store.commit('user/SET_PARENTROWS', parentRows)
        if (lastRow.type == 2) {
          if(!lastRow.customized && !row.customized) {
            console.log('缺少customized')
            return
          }
          if (row.customized == 1) {
            
          } else if (row.customized == 2) {
            
          } else if (row.customized == 3) { // 选货系统单页
            if (row.style == 1) {
              let routeData = this.$router.resolve({ path: `/selectionSys/${row.id}` });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/selectionSys/${row.id}`)
            }
          } else if (lastRow.customized == 4) { // 信息中心单页
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/infoCenter/${parentRows[0].id}/${lastRow.id}` });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/infoCenter/${parentRows[0].id}/${lastRow.id}`)
            }
          } else if (lastRow.customized == 5) { // 数据中心现货价格单页
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/dataCenter/spotPrice/${parentRows[0].id}/${lastRow.parentId}`, query: { id: lastRow.id } });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/dataCenter/spotPrice/${parentRows[0].id}/${lastRow.parentId}?id=${lastRow.id}`)
            }
          } else if (lastRow.customized == 6) { // 数据中心价差对比单页
            if (row.style == 1) {
              let routeData = this.$router.resolve({ path: `/dataCenter/chart/${parentRows[0].id}/${lastRow.parentId}`, query:{ id: lastRow.id } });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/dataCenter/chart/${parentRows[0].id}/${lastRow.parentId}?id=${lastRow.id}`)
            }
          } else if (lastRow.customized == 7) { // 数据中心购销均价单页
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/dataCenter/averagePrice/${parentRows[0].id}/${lastRow.parentId}`, query: { id: lastRow.id } });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/dataCenter/averagePrice/${parentRows[0].id}/${lastRow.parentId}?id=${lastRow.id}`)
            }
          } else if (lastRow.customized == 8) { // 购销指南交付数据单页
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/shopGuide/deliveryData/${parentRows[0].id}/${lastRow.id}`, query: { id: lastRow.id } });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/shopGuide/deliveryData/${parentRows[0].id}/${lastRow.id}?id=${lastRow.id}`)
            }
          } else if (lastRow.customized == 9) { // 购销指南交付仓库单页
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/shopGuide/warehouse/${parentRows[0].id}/${lastRow.parentId}`, query: { id: lastRow.id } });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/shopGuide/warehouse/${parentRows[0].id}/${lastRow.parentId}?id=${lastRow.id}`)
            }
          } else if (lastRow.customized == 10) { // 购销指南服务协议单页
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/shopGuide/tradeRules/${parentRows[0].id}/${lastRow.id}` });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/shopGuide/tradeRules/${parentRows[0].id}/${lastRow.id}`)
            }
          }
        } else {
          if(lastRow.template == 2) {
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/news/list/${parentRows[0].id}/${lastRow.id}` });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/news/list/${parentRows[0].id}/${lastRow.id}`)
            }
          } else if(lastRow.template == 1) {
            if (lastRow.style == 1) {
              let routeData = this.$router.resolve({ path: `/news/detail/${parentRows[0].id}/${lastRow.id}`, query: { id: lastRow.id } });
              window.open(routeData.href, '_blank');
            } else {
              this.$router.push(`/news/detail/${parentRows[0].id}/${lastRow.id}?id=${lastRow.id}`)
            }
          }
        }
      }
    },
    findRow(arr) {
      let row = arr[0]
      if (!row.children || !row.children.length) {
        return row
      }
      this.findRow(row.children)
    },
    deepTree(tree, func) {
      tree.forEach((data, index) => {
        func(data, index)
        data.children && index == 0 && this.deepTree(data.children, func) 
      })
    },
    jsonp (url, callback) {
      let callback1 = '' + callback + '_' + new Date().valueOf()
      return new Promise((resolve, reject) => {
        window[callback1] = (data) => {
          resolve(data)
          delete window[callback1]
          script.parentNode.removeChild(script)
        }
        var script = document.createElement('script')
        script.src = url + '&callback=' + callback1
        document.body.appendChild(script)
      })
    },
  },
}